import { CommonModule } from '@angular/common';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { CoreRoutingModule } from './core-routing.module';
import { HttpConfigInterceptor } from './interceptors/http-config.interceptor';
import { AuthComponent } from './pages/auth/auth.component';
import { AuthService } from '../../services/auth/auth.service';
import { environment } from '../../../environments/environment';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { FormsModule } from '@angular/forms';
import { ExamplePageComponent } from '../shared/example-page/example-page.component';

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    `${environment.ROOT_FOLDER}/assets/i18n/`,
    '.json'
  );
}

@NgModule({
  declarations: [
    AuthComponent,
    HeaderComponent,
    FooterComponent,
    SideMenuComponent,
    PageNotFoundComponent,
    NotAuthorizedComponent,
    ExamplePageComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    CoreRoutingModule,
    FormsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
  ],
  exports: [
    SideMenuComponent,
    HeaderComponent,
    FooterComponent,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only.'
      );
    }
  }
}
